export const baseURL = "https://par.dunalastair.cl/";
export const tipddytoken = "6be0dab8ba699258773276615422b9c8";
export const moodleURL = `${baseURL}webservice/rest/server.php?wstoken=`;
export const iappUrl = "https://tuclase-rnu.iapp.cl/api/rnu";

export const API = {
  dev: "http://localhost:3000/",
  prod: "https://alumnos.dunalastair.cl",
};
